import React from 'react';
import 'AppSrc/core/style/components/form/form-base-components/sub-components/inline-errors.css';
import { inlineErrorsPropShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { isObject } from 'underscore';
import { FieldWarningError } from 'AppSrc/core/components/forms/form-types/completion-review/field-warning-error';

const InlineErrors = React.memo(({
  inlineErrors,
}) => (
  <ul
    className="inline-errors"
  >
    {
      inlineErrors.map((error, i) => (
        <li
          key={error}
          className="inline-error"
        >
          {
            (isObject(error) && error.withWarningSvg) ? (
              <p className="error-message">
                <FieldWarningError className={error.className || ''} />
              </p>
            ) : (
              <p className="error-message">{error}</p>
            )
          }
        </li>
      ))
    }
  </ul>
));

InlineErrors.propTypes = {
  inlineErrors: inlineErrorsPropShape,
};


export { InlineErrors };
